export class DonorRequest{
    donorsId : number;
    
    constructor(donorsId : number)
    {
        this.donorsId = donorsId;
        
    }
}
